export default "__VITE_ASSET__095f5578__"